import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { compiler } from 'markdown-to-jsx';

import { API, useFetch } from 'app/api';
import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { Modal, ModalProps } from 'app/design-system/components/Modal';
import { Scrollbar } from 'app/design-system/components/Scrollbar';
import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';
import LinkWrapper from 'app/widgets/LinkWrapper';

import dictionary from './OfferModal.dictionary.json';

import styles from '../../Signing.module.scss';

const OfferModal: FC<ModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  const { data, loading, makeRequest } = useFetch(
    API.strapiServices.documents.getOffer,
    { skipSSR: true },
  );

  useEffect(() => {
    makeRequest();
  }, []);

  const getModalContent = () => {
    if (loading) {
      return <Spinner />;
    }

    if (!data?.content) {
      return t(dictionary.noData);
    }

    return compiler(data.content, {
      wrapper: null,
      overrides: {
        a: { component: LinkWrapper },
      },
    });
  };

  return (
    <Modal isOpen={isOpen}
           className={styles.offerModal}
           closable
           maxWidth={660}
           onClose={onClose}
           data-test="Modal-Signing">
      <Modal.Header data-test="Modal-Signing-offerHeader">
        {t(dictionary.header)}
      </Modal.Header>
      <Modal.Body>
        <Scrollbar className={styles.offerContainer}>
          <div className={classNames(styles.contentWrapper, {
            [styles.noAlignment]: data?.content,
          })}>
            {getModalContent()}
          </div>
        </Scrollbar>
      </Modal.Body>
      <Modal.Footer>
        <Button type={ButtonType.BUTTON}
                intent={ButtonIntent.DEFAULT}
                onClick={onClose}
                className={styles.footerCancelButton}
                data-test="registration-offer-cancel">
          {t(dictionary.close)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OfferModal;
